module.exports = __webpack_public_path__ + "static/img/pin-adulticide-inactive.248d971.svg";